import React from 'react';

import {UsageType} from '../../generated/graphql';
import {ExportAsCSV} from './ExportAsCSV';
import {HistoricUsageChart} from './HistoricUsageChart';
import {useHistoricUsageChartContext} from './HistoricUsageChartContextProvider';
import {TimeRangePicker} from './TimeRangePicker';

function getChartTitle(usageType: UsageType) {
  switch (usageType) {
    case UsageType.Storage:
      return 'Average monthly storage';
    default:
      return 'Usage over time';
  }
}

export const HistoricUsageTabContent = () => {
  const {usageType} = useHistoricUsageChartContext();

  return (
    <div className="flex flex-col rounded-lg border border-wb-border px-16 pb-16 pt-24">
      <div className="flex justify-between">
        <div className="flex">
          <div className="font-semibold text-moon-750 dark:text-moon-250">
            {getChartTitle(usageType)}
          </div>
          <div className="ml-12">
            <TimeRangePicker />
          </div>
        </div>
        <ExportAsCSV />
      </div>
      <HistoricUsageChart />
    </div>
  );
};
